<template>
  <div>
    <div id="container" :style="{height:height+'px',marginLeft: '-10px',marginTop: '-10px',marginRight: '-10px'}"/>
  </div>
</template>
<script>
import AMapLoader from '@amap/amap-jsapi-loader';

export default {
  name: "NewMoment",
  data() {
    return {
      loca: null,
      height: window.innerHeight - 60,
      province: null,
      city: null,
      county: null,
      level: 1,
    }
  },

  methods: {
    getIndex(count) {
      if (count < 2)
        return 0;
      else if (count < 6)
        return 1;
      else if (count < 11)
        return 2;
      else if (count < 31)
        return 3;
      else if (count < 121)
        return 4;
      else if (count < 181)
        return 5;
      else if (count < 366)
        return 6;
      else
        return 7;

    },
    timestampToDatetime(timestamp) {
      const dateObj = new Date(timestamp);
      const year = dateObj.getFullYear();
      let month = dateObj.getMonth() + 1;
      if (month < 10)
        month = '0' + month
      let day = dateObj.getDate();
      if (day < 10)
        day = '0' + day
      let hours = dateObj.getHours();
      if (hours < 10)
        hours = '0' + hours
      let minutes = dateObj.getMinutes();
      if (minutes < 10)
        minutes = '0' + minutes
      let seconds = dateObj.getSeconds();
      if (seconds < 10)
        seconds = '0' + seconds
      return year + '-' + month + '-' + day;
    },
    //初始化地图
    initMap() {
      AMapLoader.load({
        "key": "2515d5ed5d183c67772eb601550348d2", //申请好的Web端开发者Key，首次调用load时必填
        "version": "2.0",  //指定要加载的JSAPI的版本，缺省时默认为1.4.15
        "plugins": ['AMap.Autocomplete', 'AMap.PlaceSearch', 'AMap.Scale', 'AMap.Loca', 'AMap.OverView', 'AMap.ToolBar', 'AMap.MapType', 'AMap.PolyEditor', 'AMap.CircleEditor'],
        "Loca": {  //是否加载 Loca,缺省不加载
          "version": '2.0.0'  //Loca 版本,缺省1.3.2
        }
      }).then((AMap) => {
        let map = new AMap.Map('container', {
          zoom: 6,
          showLabel: false,
          viewMode: '3D',
          center: [104.2, 31.5],
          mapStyle: 'amap://styles/dark',
        });

        var loca = (window.loca = new Loca.Container({
          map,
        }));

        var geo = new Loca.GeoJSONSource({
          url: 'https://birthcircle.cn/api/carlocation/getLocationListWithRegion?carCode=LB37742ZXLB071881&Level=' + this.level + '&province=' + this.province + '&city=' + this.city + '&county=' + this.county,
        });

        var colors = [
          'rgba(254,255,198,0.95)',
          'rgba(255,238,149,0.95)',
          'rgba(255,217,99,0.95)',
          'rgba(255,175,43,0.95)',
          'rgba(255,135,24,0.95)',
          'rgba(234,10,0,0.95)',
          'rgba(195,0,0,0.95)',
          'rgba(139,0,0,0.95)',
        ];

        var pl = new Loca.PolygonLayer({
          zIndex: 120,
          opacity: 1,
          shininess: 1,
        });

        pl.setSource(geo);
        pl.setStyle({
          height: 0,
          topColor: (index, f) => {
            return colors[this.getIndex(f.properties['count'])];
          },
          sideColor: '#000',
          // label配置即AMap.LabelMarker的配置
          label: {
            text: {
              // 每个配置项都可通过回调函数动态配置
              content: (index, feat) => feat.properties.name,
              offset: [0, 10],
              style: {
                fontSize: 12,
                fontWeight: 'normal',
                fillColor: (index, f) => {
                  return colors[this.getIndex(f.properties['count'])];
                },
                strokeColor: '#000',
                strokeWidth: 2,
                padding: '2, 5',
              },
            },
          },
          // 通过labelAltitude控制标注相对于图形顶面的海拔高度，单位同altitude配置项，默认为0
          labelAltitude: 0
        });
        loca.add(pl);

        // 图例
        // eslint-disable-next-line no-undef
        new Loca.Legend({
          loca: loca,
          title: {
            label: '途径天数',
            fontColor: 'rgba(255,255,255,1)',
            fontSize: '16px',
          },
          style: {
            backgroundColor: 'rgba(0,0,0,0.3)',
            left: '20px',
            bottom: '40px',
            fontSize: '12px',
          },
          dataMap: [
            {label: '> 365', color: colors[7]},
            {label: '<= 365', color: colors[6]},
            {label: '<= 180', color: colors[5]},
            {label: '<= 120', color: colors[4]},
            {label: '<= 30', color: colors[3]},
            {label: '<= 10', color: colors[2]},
            {label: '<= 5', color: colors[1]},
            {label: '<= 1', color: colors[0]},
          ],
        });

        // 动画
        map.on('complete', function () {
          pl.addAnimate({
            key: 'radius',
            value: [0, 1],
            duration: 2000,
            easing: 'ElasticOut',
            // yoyo: false,
            // repeat: 1,
          });
          pl.show(600);
        });

        // 创建纯文本标记
        var text = new AMap.Text({
          text: '纯文本标记',
          anchor: 'center', // 设置文本标记锚点
          draggable: true,
          cursor: 'pointer',
          angle: 0,
          visible: false,
          offset: [0, -25],
          style: {
            'padding': '5px 10px',
            'margin-bottom': '1rem',
            'border-radius': '.25rem',
            'background-color': 'rgba(0,0,0,0.5)',
            // 'width': '12rem',
            'border-width': 0,
            'box-shadow': '0 2px 6px 0 rgba(255, 255, 255, .3)',
            'text-align': 'center',
            'font-size': '16px',
            'color': '#fff',
            'white-space': 'pre',
          },
        });
        text.setMap(map);

        /*map.on('mousemove', (e) => {
          const feat = pl.queryFeature(e.pixel.toArray());
          if (feat) {
            text.show();
            text.setText(feat.properties.name + ' => 途径天数：' + feat.properties.count + '\r\n最早时间：' + this.timestampToDatetime(feat.properties.first) + '\r\n最晚时间：' + this.timestampToDatetime(feat.properties.last));
            text.setPosition(e.lnglat);
          }
        });*/

        map.on('click', (e) => {
          if (this.level >= 4) {
            return;
          }
          const feat = pl.queryFeature(e.pixel.toArray());
          if (feat) {
            this.level = this.level + 1;
            this.province = feat.properties.province;
            this.city = feat.properties.city;
            this.county = feat.properties.county;
            var geo = new Loca.GeoJSONSource({
              url: 'https://birthcircle.cn/api/carlocation/getLocationListWithRegion?carCode=LB37742ZXLB071881&Level=' + this.level + '&province=' + this.province + '&city=' + this.city + '&county=' + this.county,
            });
            pl.setSource(geo);
          }
        });
      })
    },

  },

  mounted() {

    if (!this.map) {
      this.initMap();
    }
  }
}
</script>
